var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../ProgressIndicator.css";
import "../../common/styles.css";
import { InternalProgressBar } from "./InternalProgressBar";
import SpaceBetween from "@cloudscape-design/components/space-between";
import classNames from "classnames";
function isString(val) {
    return typeof val === "string" || val instanceof String;
}
/**
 * Visualize the progression of launching a session or background works.
 * If it is not possible to quantify the progress of the process, it would
 * need to show an indeterminate progress bar instead.
 */
export var ProgressIndicator = function (_a) {
    var _b, _c, _d;
    var _e = _a.determinate, determinate = _e === void 0 ? false : _e, _f = _a.progress, progress = _f === void 0 ? 0 : _f, _g = _a.space, space = _g === void 0 ? "m" : _g, props = __rest(_a, ["determinate", "progress", "space"]);
    return (_jsxs(SpaceBetween, __assign({ size: space, "data-size": props.size }, { children: [_jsx("div", __assign({ className: classNames({ "center-text": isString(props.header) }) }, { children: props.header })), _jsx(InternalProgressBar, { ariaLabel: props.ariaLabel, width: (_b = props.indicatorStyle) === null || _b === void 0 ? void 0 : _b.width, determinate: determinate, progress: progress, valueColor: (_c = props.indicatorStyle) === null || _c === void 0 ? void 0 : _c.valueColor, backgroundColor: (_d = props.indicatorStyle) === null || _d === void 0 ? void 0 : _d.backgroundColor }), _jsx("div", __assign({ className: classNames({ "center-text": isString(props.footer) }) }, { children: props.footer }))] })));
};
